import CustomSVG from "../svg";
import classes from "./text_input.module.css";
import SvgError from '@/assets/svg/icons/alert-circle.svg';
import ChevronDown from '@/assets/svg/icons/chevron-down.svg';
import ChevronUp from '@/assets/svg/icons/chevron-up.svg';

function TextInput ({label, hint, error, leading_icon, leading_icon_click, help_icon, help_icon_text, help_icon_click, required_mark, textarea_max, width_100 = false, setValue, inputRef, ...props}) {
    if(error && !help_icon) help_icon = SvgError;

    let temp_leading_icon;
    if(typeof leading_icon === "string") {
        temp_leading_icon = <i className={`color-gray-500 bi bi-icon bi-icon-20 ${leading_icon} ${classes["leading-icon"]} ${leading_icon_click ? "pointer" : ""}`} onClick={leading_icon_click} />
    } else {
        temp_leading_icon = <CustomSVG SvgFunction={leading_icon} className={`stroke-gray-500 rect-stroke-gray-500 circle-stroke-gray-500 ${classes["leading-icon"]} ${leading_icon_click ? "pointer" : ""}`} height={20} width={20} onClick={leading_icon_click} />
    }

    let temp_help_icon;
    if(help_icon_text) {
        temp_help_icon = <span className={`color-gray-900 text-md-regular ${classes["help-icon"]}`}>{help_icon}</span>
    } else if(typeof help_icon === "string") {
        temp_help_icon = <i className={`bi bi-icon bi-icon-16 ${help_icon} ${classes["help-icon"]} ${help_icon_click ? "pointer" : ""}`} onClick={help_icon_click} />
    } else {
        temp_help_icon = <CustomSVG SvgFunction={help_icon} className={`${error ? "stroke-error-500 rect-stroke-error-500 circle-stroke-error-500" : "stroke-gray-500 rect-stroke-gray-500 circle-stroke-gray-500"} ${classes["help-icon"]} ${help_icon_click ? "pointer" : ""}`} height={16} width={16} onClick={help_icon_click} />
    }

    props.className = `${props.className} ${classes.input} ${error ? `${classes["error"]}` : ""} text-md-regular ${textarea_max ? `${classes["grid-height"]} ${classes["z-index-parent"]} w-100 overflow-hidden` : ""} ${width_100 ? "w-100" : ""}` ;
    if(props.type !== "textarea") props.className = `${props.className} ${leading_icon ? `${classes["input-leading-icon"]}` : ""} ${help_icon ? `${classes["input-help-icon"]}` : ""}`;
    
    const incrementValue = () => {
        if(isNaN(props.value)) return;
        const currentValue = Number(props.value);
        const nextValue = (props.max !== undefined ? Math.min(currentValue + 1, Number(props.max)) : currentValue + 1);
        setValue(nextValue);
    }

    const decrementValue = () => {
        if(isNaN(props.value)) return;
        const currentValue = Number(props.value);
        const nextValue = (props.min !== undefined ? Math.max(currentValue - 1, Number(props.min)) : currentValue - 1);
        setValue(nextValue);
    }

    return <div className={`${classes["text-input"]} w-100`}>
        {label && <div className="d-flex flex-row text-nowrap gap-1 color-gray-700 text-sm-medium">
            {label}
            {required_mark && <div className="color-error-600">*</div>}
        </div>}
        {props.type === "textarea"
        ? textarea_max
            ? <div className={`d-grid w-100`}>
                <div className={`d-flex flex-column text-md-regular ${classes["grid-height"]} ${classes["grid-placeholder"]}`} >
                    {props.value}
                </div>
                <textarea {...props} />
            </div>
            : <textarea {...props} ref={inputRef} />
        : <div className={`${classes["input-container"]} w-100`}>
            {leading_icon && temp_leading_icon}
            <input {...props} ref={inputRef} />
            {help_icon && temp_help_icon}
            {props.type === "number" && <div className={`${classes["increment-and-decrement"]}`}>
                <CustomSVG className="stroke-gray-500 pointer" SvgFunction={ChevronUp} height={14} width={14} onClick={incrementValue} />
                <CustomSVG className="stroke-gray-500 pointer" SvgFunction={ChevronDown} height={14} width={14} onClick={decrementValue} />
            </div>}
        </div>}
        {hint && <div className={`${error ? "color-error-500" : "color-gray-500"} text-sm-regular`}>{hint}</div>}
    </div>
};
  
export default TextInput;